import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { TranslatePipe } from '@ngx-translate/core';
import { ClickKeydownEnterSpaceDirective } from '../../directives/clickKeyDownEnterSpace.directive';
import { SvgIconComponent } from '../../form-elements/components/svg-icon/svg-icon.component';
import { NgIf } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { PageHeaderComponent } from '../page-header/page-header.component';

@Component({
  selector: 'qvs-page-header-close',
  templateUrl: './page-header-close.component.html',
  styleUrls: ['./page-header-close.component.scss'],
  standalone: true,
  imports: [PageHeaderComponent, IonicModule, NgIf, SvgIconComponent, ClickKeydownEnterSpaceDirective, TranslatePipe]
})
export class PageHeaderCloseComponent implements OnDestroy {
  @Input() title: string;
  @Input() showIcon = true;
  @Output() closed: EventEmitter<void> = new EventEmitter<void>();
  destroyed$ = new Subject<boolean>();

  ngOnDestroy() {
    this.destroyed$.next(true);
  }
}
